import { computed } from 'vue';

import { useQueryV2 } from '@libs/use';

import * as API from '../requests';

import { CASH_QUERY_KEYS } from '../constants';

export default function useGetSyncOnlineStatus() {
  const {
    result,
    isPending: isLoadingSyncOnlineStatus,
    ...query
  } = useQueryV2<boolean>(() => API.getSyncOnlineStatus(), {
    key: CASH_QUERY_KEYS.syncOnlineStatus,
  });

  const syncOnlineStatus = computed(() => result.value?.data);

  return { syncOnlineStatus, isLoadingSyncOnlineStatus, ...query };
}
